import React, { useState } from "react";
export default function ForgotPasswordModal({ onClose }: { onClose: () => void }) {
    const [form, setForm] = useState({
        name: "",
        phone: "",
        province: "",
        district: "",
        ward: "",
        address: "",
        isDefault: false,
    });
    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value, type } = e.target;
        const checked = 'checked' in e.target ? e.target.checked : false;
        setForm(prev => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value
        }));
    };
    return (
        <div
            role="presentation"
            className="undefined styles_modalItem__YKbSY"
            aria-describedby="transition-modal-description"
            style={{
                position: "fixed",
                zIndex: 1300,
                inset: 0,
            }}
        >
            <div
                onClick={onClose}
                aria-hidden="true"
                style={{
                    zIndex: -1,
                    position: "fixed",
                    inset: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    WebkitTapHighlightColor: "transparent",
                }}
            />

            <div tabIndex={0} data-test="sentinelStart" />

            <div
                className="styles_auth_modal_content__gD2DP"
                tabIndex={-1}
                style={{ width: "30rem" }}
            >
                {/* HEADER */}
                <div className="MuiGrid-root styles_auth_modal_header__8MVV9 MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-content-xs-space-between">
                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-10">
                        <header className="styles_auth_modal_title__7Ht8G">
                            Khôi phục mật khẩu
                        </header>
                    </div>

                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-1">
                        <button
                            className="MuiButtonBase-root MuiIconButton-root styles_auth_modal_close__CfXli"
                            type="button"
                            aria-label="close"
                            onClick={onClose}
                        >
                            <span className="MuiIconButton-label">
                                <svg
                                    className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall"
                                    focusable="false"
                                    viewBox="0 0 24 24"
                                    aria-hidden="true"
                                >
                                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" />
                                </svg>
                            </span>
                            <span className="MuiTouchRipple-root" />
                        </button>
                    </div>
                </div>

                {/* BODY */}
                <div className="styles_auth_modal_body__le_XM">
                    <div>
                        <div>
                            <div className="styles_desc__gww0i">
                                Nhập số điện thoại cần khôi phục
                            </div>

                            <form>
                                <div className="MuiGrid-root styles_formGridFieldName___9PUk MuiGrid-item MuiGrid-grid-xs-12 w-full my-32px">
                                    <div className="MuiFormControl-root MuiFormControl-fullWidth">
                                        <div className="MuiInputBase-root MuiOutlinedInput-root sc-242007b2-0 cWOwtw styles_input__a0YjR MuiInputBase-formControl px-16px">
                                            <input
                                                name="name"
                                                placeholder="Nhập số điện thoại"
                                                type="text"
                                                value={form.name}
                                                className="MuiInputBase-input MuiOutlinedInput-input"
                                                onChange={handleChange}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="styles_center__ijy9t MuiBox-root css-0">
                                    <button
                                        className="MuiButtonBase-root MuiButton-root MuiButton-text sc-2362e412-0 iQEreR styles_btn__7hepk"
                                        type="submit"
                                    >
                                        <span className="MuiButton-label">
                                            Gửi mã xác thực qua SMS
                                        </span>
                                        <span className="MuiTouchRipple-root" />
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div tabIndex={0} data-test="sentinelEnd" />
        </div>
    );
}
